import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17 3.94737C17 3.42632 16.55 3 16 3C15.45 3 15 3.42632 15 3.94737H9C9 3.42632 8.55 3 8 3C7.45 3 7 3.42632 7 3.94737H6C4.35 3.94737 3 5.22632 3 6.78947V18.1579C3 19.7211 4.35 21 6 21H12C12.55 21 13 20.5737 13 20.0526C13 19.5316 12.55 19.1053 12 19.1053H6C5.45 19.1053 5 18.6789 5 18.1579V11.5263H19V12.4737C19 12.9947 19.45 13.4211 20 13.4211C20.55 13.4211 21 12.9947 21 12.4737V6.78947C21 5.22632 19.65 3.94737 18 3.94737H17ZM8 7.73684C7.45 7.73684 7 7.31053 7 6.78947V5.84211H6C5.45 5.84211 5 6.26842 5 6.78947V9.63158H19V6.78947C19 6.26842 18.55 5.84211 18 5.84211H17V6.78947C17 7.31053 16.55 7.73684 16 7.73684C15.45 7.73684 15 7.31053 15 6.78947V5.84211H9V6.78947C9 7.31053 8.55 7.73684 8 7.73684Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M18 21C17.45 21 17 20.5737 17 20.0526V19.1053H16C15.45 19.1053 15 18.6789 15 18.1579C15 17.6368 15.45 17.2105 16 17.2105H17V16.2632C17 15.7421 17.45 15.3158 18 15.3158C18.55 15.3158 19 15.7421 19 16.2632V17.2105H20C20.55 17.2105 21 17.6368 21 18.1579C21 18.6789 20.55 19.1053 20 19.1053H19V20.0526C19 20.5737 18.55 21 18 21Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}